import { PrimeNGConfig, SelectItem } from 'primeng/api';
import { Observable, Subject, of } from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';

import { GetIpResponce } from '../models/ip_response';
import { TranslateArray, translations } from '../translations/translations';

@Injectable({
  providedIn: 'root',
})
export class SettingsService {
  public maxCountAttachment = 10;

  public racesTypes: SelectItem[] = [
    { label: 'header_all', value: 'all', icon: 'pi pi-users' },
    { label: 'org', value: 'org', icon: 'pi pi-star' },
    { label: 'comp', value: 'comp', icon: 'pi pi-user' },
    //TODO Раскомментирвать когда будет готов запрос на получение этого списка
    // { label: 'race_changes', value: 'race_changes', icon: 'pi pi-pencil' },
  ];

  public selectedRacesType: SelectItem = this.racesTypes[0];

  public langs: SelectItem[] = [
    { label: 'Русский', value: 'ru' },
    { label: 'English', value: 'us' },
  ];

  public selectedLang: "ru" | "us" = this.langs[0].value;
  public selectedLangSource: Subject<void> = new Subject();
  public selectedLang$: Observable<void>;

  public translate: TranslateArray = translations;

  public genders: { label: string; value: number }[] = [];
  public docTypes: { code: string; name: string }[] = [];

  public roles = [
    {
      langIndex: 'owner',
      value: 'OWNER',
    },
    {
      langIndex: 'main_org',
      value: 'MAIN_ORG',
    },
    {
      langIndex: 'judge',
      value: 'JUDGE',
    },
    {
      langIndex: 'marshal',
      value: 'MARSHAL',
    },
  ];

  CALENDER_CONFIG_EN = {
    firstDayOfWeek: 0,
    dayNames: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    today: 'Today',
    clear: 'Clear',
  };
  CALENDER_CONFIG_RU = {
    firstDayOfWeek: 0,
    dayNames: ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'],
    dayNamesShort: ['Вск', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    dayNamesMin: ['Вск', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
    monthNamesShort: ['Янв', 'Фев', 'Март', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сент', 'Окт', 'Нояб', 'Дек'],
    today: 'Сегодня',
    clear: 'Очистить',
  };
  timeoutForCall: number = 5 * 60 * 1000;
  settings = {
    urlGTM: '',
    urlFileUpload: 'https://fget.marshalone.ru/files',
    urlFileDownload: 'https://fget.marshalone.ru/files',
    emptyUserPhoto: 'b40cdc0799014e64b3c2fbc4f0ce6ae7',
    emptyLogo: 'd189538773744aefb338ff690b161036',
    emptyTitle: '19a38bc7db894ac89a599a555efdedda',
    socket: 'https://tracker.marshalone.ru',
  };
  currentUrlPath: any;
  currentUrlData: string[] = [];
  currentTranslate: { [key: string]: string } = this.translate[this.selectedLang];
  GOOGLE_API_KEY = 'AIzaSyCMIdACneUHvYNoucUXbPilDs8LSldGmCc';
  public marshalUrl: string = 'https://marshalone.ru';

  TABLE_TYPE = {
    PROGRESS: 'PROGRESS',
    PROGRESSV2: 'PROGRESSV2',
    MAP: 'MAP',
    DOCUMENTS: 'DOCUMENTS',
  };

  time_states: Array<SelectItem> = [
    { label: 'timePoint', value: 1 },
    { label: 'timePrevPoint', value: 2 },
    { label: 'timeStartPoint', value: 3 },
    { label: 'timeStartUser', value: 4 },
    { label: 'timeDeltaLider', value: 5 },
  ];

  constructor(
    private config: PrimeNGConfig,
    public router: Router,
    private http: HttpClient
  ) {
    this.selectedLang$ = this.selectedLangSource.pipe();
    this.selectedLang$.subscribe(() => {
      this.currentTranslate = this.translate[this.selectedLang];
      this.setLang(this.selectedLang);
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        const urlDelimitators = new RegExp(/[?//,;&:#$+=]/);
        const urlDataArray = event.url.slice(1).split(urlDelimitators);
        this.currentUrlPath = urlDataArray[0];
        this.currentUrlData = urlDataArray;
      }
    });

    const browserLang = this.langs.find((lang) => {
      return lang.value === navigator.language.split('-')[0];
    });
    if (browserLang) {
      this.selectedLang = browserLang.value;
    }
  }

  async setLang(value: string): Promise<void> {
    const findLang = this.langs.find((lang) => lang.value === value);
    if (findLang) {
      this.selectedLang = findLang.value;
      this.genders = [
        {
          label: this.translate[this.selectedLang]['undefGender'],
          value: 0,
        },
        {
          label: this.translate[this.selectedLang]['manGender'],
          value: 1,
        },
        {
          label: this.translate[this.selectedLang]['womanGender'],
          value: 2,
        },
      ];
      if (value === 'ru') {
        this.config.setTranslation(this.CALENDER_CONFIG_RU);
      } else {
        this.config.setTranslation(this.CALENDER_CONFIG_EN);
      }
    }
  }

  getTranslate(tag: string, args: string[] = []): string {
    let template = this.translate[this.selectedLang][tag] ? this.translate[this.selectedLang][tag] : `Not found translate for "${tag}"`;
    let index = 1;
    args.forEach((arg) => {
      template = template.split(`$${index}`).join(arg);
      ++index;
    });
    return template;
  }

  private ipCache: GetIpResponce | undefined = undefined;
  private ipCacheTime: number = 0;
  private readonly CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 часа

  getIp(): Observable<GetIpResponce> {
    return new Observable(observer => {
      let countryCode = 'RU'; // Дефолт

      try {
        // Инициализируем интернационализацию и смотрим системную таймзону
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        // Пример таймзоны: "Europe/Moscow", "Asia/Yekaterburg", "Europe/Paris"
        if (timeZone) {
          if (timeZone.startsWith('Europe/') &&
            ['Moscow', 'Saratov', 'Samara', 'Kaliningrad'].some(city => timeZone.includes(city))) {
            countryCode = 'RU';
          } else if (timeZone.startsWith('Asia/')) {
            // Большинство азиатских таймзон в РФ содержат крупные города РФ
            const ruAsiaCities = ['Novosibirsk', 'Krasnoyarsk', 'Irkutsk', 'Yakutsk', 'Vladivostok', 'Magadan', 'Kamchatka', 'Anadyr', 'Yekaterinburg', 'Omsk', 'Chelyabinsk', 'Tyumen', 'Ufa', 'Perm'];
            if (ruAsiaCities.some(city => timeZone.includes(city))) {
              countryCode = 'RU';
            }
          } else {
            // Если таймзона не российская, можно попробовать вытащить код из языка браузера (например, "ru-RU" -> "RU")
            const locale = navigator.language || (navigator.languages && navigator.languages[0]);
            if (locale && locale.includes('-')) {
              countryCode = locale.split('-')[1].toUpperCase();
            }
          }
        }
      } catch (e) {
        console.warn('Не удалось определить страну через Intl, применен дефолт RU');
      }

      const response: GetIpResponce = { country: countryCode };
      observer.next(response);
      observer.complete();
    });
  }

  // Метод, проверяющий, является ли иконка кастомной (т.е., из assets)
  isCustomIcon(icon: string): boolean {
    return true; // icon === 'sport_ski' || icon === 'sport_triatlon' || icon === 'sport_two_wheeler';
  }

  // Метод, возвращающий путь к иконке
  getIconPath(icon: string): string {
    return `/assets/icons/${icon}.png`;
  }
}
export { TranslateArray };
